import React from "react";
import style from './style.module.scss';

export const CreativeBorder = ({borderColor, borderWidth}) => {
    const creativeBorderStyle = {borderColor, borderWidth: `${borderWidth}px`};
    return <div className={style.creativeBorder} style={creativeBorderStyle}> </div>
}